<template>
  <el-dialog
    :title="$t('app.adjustment')"
    :visible.sync="dialogVisible"
    width="1400px"
  >
    <el-row>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>當前學生</span>
          </div>
          <el-row class="info">
            <el-col :span="12" style="margin-bottom: 15px">{{
              $t("app.room") + ":" + room
            }}</el-col>
            <el-col :span="12" style="margin-bottom: 15px">{{
              $t("app.bed") + ":" + bed
            }}</el-col>
            <el-col :span="12" style="margin-bottom: 15px"
              >{{ $t("app.studentNumber") + ":" + studentNumber }}
            </el-col>
            <el-col :span="12" style="margin-bottom: 15px">
              {{ $t("app.gender") + ":" + gender }}
            </el-col>
            <el-col :span="12" style="margin-bottom: 15px">
              {{ $t("app.nameEnglish") + ":" + nameEnglish }}
            </el-col>
            <el-col :span="12" style="margin-bottom: 15px">
              {{ $t("app.nameChina") + ":" + nameChina }}
            </el-col>
            <el-col :span="24" style="margin-bottom: 15px">{{
              $t("app.contactInformation") + ":" + contactInformation
            }}</el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>選擇的學生</span>
          </div>
          <el-row class="info">
            <el-col :span="24" style="margin-bottom: 15px"></el-col>
            <el-col :span="12" style="margin-bottom: 15px"
              >{{ $t("app.studentNumber") + ":" }}
              <el-input
                size="small"
                style="width: 200px"
                :placeholder="$t('app.validation.studentNumber')"
                v-model="selectStu.code"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  size="small"
                  icon="el-icon-search"
                  @click="getInfo"
                ></el-button> </el-input
            ></el-col>
            <el-col :span="12" style="margin-bottom: 15px">
              {{ $t("app.gender") + ":" + selectStu.gender }}
            </el-col>
            <el-col :span="12" style="margin-bottom: 15px; word-break: normal">
              {{ $t("app.nameEnglish") + ":" + selectStu.nameEnglish }}
            </el-col>
            <el-col :span="12" style="margin-bottom: 15px">
              {{ $t("app.nameChina") + ":" + selectStu.nameChina }}
            </el-col>
            <el-col :span="24" style="margin-bottom: 15px">{{
              $t("app.contactInformation") + ":" + selectStu.contactInformation
            }}</el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 1rem">
      備註：
      <el-input
        type="textarea"
        :rows="3"
        placeholder="最大不超過500字"
        maxlength="500"
        v-model="remark"
      >
      </el-input>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="swapBed"
        >{{ $t("app.exchange") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { swapBed } from "@/api/dormitoryManagement/list";
import { getStuInfo, saveAdjustment } from "@/api/dormitoryManagement/list";
export default {
  data() {
    return {
      dialogVisible: false,
      studentNumber: "",
      room: "",
      bed: "",
      gender: "",
      nameEnglish: "",
      nameChina: "",
      contactInformation: "",
      loading: false,
      enable: "",
      remark: "",
      selectStu: {
        code: "",
        gender: "",
        nameEnglish: "",
        nameChina: "",
        contactInformation: "",
      },
    };
  },
  methods: {
    getInfo() {
      getStuInfo({ studentCode: this.selectStu.code })
        .then((res) => {
          console.log(res)
          this.enable = true;
          this.selectStu.code = res.data.studentId;
          this.selectStu.gender = res.data.gender;
          this.selectStu.nameEnglish = res.data.fullName;
          this.selectStu.nameChina = res.data.chineseName;
          this.selectStu.contactInformation = res.data.telMobile;
        })
        .catch(() => {
          this.enable = false;
        });
    },
    edit(row) {
      this.enable = false;
      this.dialogVisible = true;
      this.studentNumber = row.studentNumber || "";
      this.room = row.room || "";
      this.bed = row.bed || "";
      this.gender = row.gender || "";
      this.nameEnglish = row.nameEnglish || "";
      this.nameChina = row.nameChina || "";
      this.contactInformation = row.contactInformation || "";
      this.selectStu.code = "";
      this.selectStu.gender = "";
      this.selectStu.nameEnglish = "";
      this.selectStu.nameChina = "";
      this.selectStu.contactInformation = "";
      this.remark = "";
    },
    swapBed() {
      if (!this.studentNumber) {
        this.$message({
          message: "沒有學生可進行交換",
          type: "warning",
        });
        return;
      }
      if (!this.enable) {
        this.$message({
          message: this.$t("app.noStuFound"),
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        swapBed({
          OriginStudentCode: this.studentNumber,
          TargetStudentCode: this.selectStu.code,
          Remark: this.remark,
        })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    handleClose() {
      if (!this.enable) {
        this.$message({
          message: this.$t("app.noStuFound"),
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        saveAdjustment({
          RoomIndex: this.room,
          Bed: this.bed,
          StudentCode: this.selectStu.code,
          Remark: this.remark,
        })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.$emit("adjustSuccess");
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.info .el-col {
  height: 30px;
  line-height: 30px;
}
</style>
